import { render, staticRenderFns } from "./BottomBacktop.vue?vue&type=template&id=4a2be600&"
import script from "./BottomBacktop.vue?vue&type=script&lang=js&"
export * from "./BottomBacktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports